import React, { useState, useEffect } from 'react';
import { MotifTextLink, MotifIcon, MotifChip } from '@ey-xd/motif-react';
import { useRecoilValue } from 'recoil';
import {
  Recoil_Selected_Account_State,
  Current_User,
  Recoil_All_Accounts_Quarter_State,
  System_Date_Time_State,
  Recoil_Quarter_State,
  Refresh_Pills_Status_State,
} from '@recoil/recoil';
import { actionIcLaunch24px } from '@ey-xd/motif-react/assets/icons';

import {
  SubmitButtonContainer,
  Hyperlink,
  TitleContainer,
  TitleTextContainer,
  SubHeaderTopContainerGcsp,
  SubHeaderTopTitle,
  TitleAccount,
  TitleText,
  SubHeaderTopHyperlink,
} from '@atoms/subHeaderText/subHeader.styles';
import { getAlertBarDetails, logError } from '@util/commonFunctions';
import { PAGE } from '@constants/commonConstants';

const SubHeaderTopGcsp = () => {
  const selectedAccount = useRecoilValue(Recoil_Selected_Account_State);
  const currentUser = useRecoilValue(Current_User);
  const allAccountsQuarterData = useRecoilValue(Recoil_All_Accounts_Quarter_State);
  const [quarterChipInfo, setQuarterChipInfo] = useState(null); // eslint-disable-line
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  const quarterData = useRecoilValue(Recoil_Quarter_State);
  const refreshPillStatus = useRecoilValue(Refresh_Pills_Status_State);

  let alertStatusDetails;

  useEffect(() => {
    if (quarterData !== null && currentUser !== null && allAccountsQuarterData !== null) {
      const interval = setInterval(() => {
        if (localStorage.getItem('isReadOnly')) {
          getMotifChip();
          clearInterval(interval);
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [quarterData, currentUser, allAccountsQuarterData, refreshPillStatus]);

  const getMotifChip = async () => {
    const apiPayload = {
      email: currentUser.email,
      role: currentUser.role,
      month: quarterData.month.toLowerCase(),
      year: quarterData.fiscal_year,
      accountId: currentUser.account_id,
      read_only: localStorage.getItem('isReadOnly') === 'true' ? true : false,
    };

    try {
      alertStatusDetails = await getAlertBarDetails(
        allAccountsQuarterData[apiPayload.role],
        apiPayload,
        PAGE.FORECAST,
        systemDateTime,
      );

      setQuarterChipInfo(alertStatusDetails);
    } catch (error) {
      logError('getAlertBarDetails', error);
    }
  };

  const getUserForecastDueInfo = dueDetails => {
    const chipStyle = {
      color: '#ffffff',
    };
    const shouldApplyStyle = dueDetails.chipType === 'outlined';
    const isDisabled = dueDetails.chipTitle === 'Read-Only';

    return (
      <MotifChip
        variant={dueDetails.chipVariant}
        type={dueDetails.chipType}
        style={shouldApplyStyle ? chipStyle : undefined}
        disabled={isDisabled}
      >
        {dueDetails.chipTitle}
      </MotifChip>
    );
  };

  const onHyperlinkClick = () => {
    if (
      localStorage.getItem('isSuperUser') == 'true' &&
      localStorage.getItem('targetUserEmail') != 'null'
    ) {
      // Set flag to use userEmail for GCSP hyperlink operations(CRM and LENS) in super user mode
      // Allow navigation - don't prevent it with userEmail for Super User
      localStorage.setItem('isGcspHyperlinkOperation', 'true');
    } else {
      // Regular user operation
      localStorage.setItem('isGcspHyperlinkOperation', 'false');
    }
  };

  return (
    <>
      {quarterData !== null && quarterChipInfo !== null ? (
        <SubHeaderTopContainerGcsp>
          <TitleContainer>
            <TitleTextContainer>
              <SubHeaderTopTitle>
                <TitleAccount>{selectedAccount?.accountName}:</TitleAccount>
                <TitleText>
                  3 Months{' '}
                  {quarterData?.quarter_start_date === quarterData?.current_month_start_date
                    ? `& ${quarterData?.quarter} Forecast`
                    : 'Forecast'}
                </TitleText>
              </SubHeaderTopTitle>
            </TitleTextContainer>
            {getUserForecastDueInfo(quarterChipInfo)}
          </TitleContainer>

          <SubmitButtonContainer>
            <Hyperlink>
              <MotifTextLink
                variant="alt"
                href={
                  selectedAccount
                    ? `${process.env.REACT_APP_ACCOUNT_LENS_URL}app/dashboard/pipeline/${selectedAccount.ey_dunsnumber}`
                    : null
                }
                target="_blank"
                onClick={e => {
                  onHyperlinkClick(e, 'LENS');
                }}
              >
                <MotifIcon src={actionIcLaunch24px} style={{ color: '#FFE600' }} />
                <SubHeaderTopHyperlink>View Account in LENS</SubHeaderTopHyperlink>
              </MotifTextLink>
            </Hyperlink>
            <Hyperlink>
              <MotifTextLink
                variant="alt"
                href={
                  selectedAccount
                    ? `${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_OPP_NAME_URL_APP_ID}&forceUCI=1&pagetype=entityrecord&etn=account&id=${selectedAccount.account_id}`
                    : null
                }
                target="_blank"
                onClick={e => {
                  onHyperlinkClick(e, 'CRM');
                }}
              >
                <MotifIcon src={actionIcLaunch24px} style={{ color: '#FFE600' }} />
                <SubHeaderTopHyperlink>View Opportunites in EY CRM</SubHeaderTopHyperlink>
              </MotifTextLink>
            </Hyperlink>
          </SubmitButtonContainer>
        </SubHeaderTopContainerGcsp>
      ) : null}
    </>
  );
};

export default SubHeaderTopGcsp;
